// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.dev.cmona.de/auto-open-api-spec.yaml 1.9.0
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for validating Practitioner web access login.
 * @see #/components/schemas/PractitionerLogInWithRfidRequest - reference to schema in open-api-spec.yaml
 * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
 * @version 1.9.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface PractitionerLogInWithRfidRequest {
    /**
     * The value of the RFID chip that is linked to the practitioner
     *
     */
    rfid: string;
    /**
     * Device MAC address
     *
     */
    device_id?: string | null;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for PractitionerLogInWithRfidRequest
 */
export namespace PractitionerLogInWithRfidRequest {
    /**
     * PractitionerLogInWithRfidRequest Frontend Model with camelCase properties
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The value of the RFID chip that is linked to the practitioner
         * @type string (`dataFormat` is missing)
         */
        rfid: string;
        /**
         * Device MAC address
         * @type string (`dataFormat` is missing)
         */
        deviceId?: string | null;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * PractitionerLogInWithRfidRequest DTO
     * Transforms PractitionerLogInWithRfidRequest model from/to API object
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend PractitionerLogInWithRfidRequest model */
        static toModel(obj: PractitionerLogInWithRfidRequest): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend PractitionerLogInWithRfidRequest model */
        static toApi(obj: Model): PractitionerLogInWithRfidRequest {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as PractitionerLogInWithRfidRequest;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
